import { ColumnSectionProps } from 'src/components/blocks/BlockColumnSection'
import { items } from '../Blocks/BlockColumnSection/static'

export function blockSectionColumnTransformer({
  t,
}: {
  t: any
}): ColumnSectionProps | undefined {
  return {
    title: t('block_column_section_title'),
    items,
  }
}
